import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { importProvidersFrom } from '@angular/core';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { ApplicationConfig } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideRouter, withRouterConfig } from '@angular/router';
import { xpoConfigManagerProvider } from '@xpo-ltl/config-manager';
import { xpoAuthConfigManagerConfiguration } from '@xpo-ltl/ngx-auth';
import { XpoPageNotFoundRoutingModule } from '@xpo-ltl/ngx-ltl-core/error-page';
import { XpoSnackBarModule } from '@xpo-ltl/ngx-ltl-core/snack-bar';
import { environment } from '../environments/environment';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    xpoConfigManagerProvider(
      xpoAuthConfigManagerConfiguration({
        firebaseOptions: environment.firebase,
        configFileUrl: './assets/config.json',
      })
    ),
    provideAnimations(),
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(appRoutes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
    // Registers the wildcard "page not found" route after the app routes
    importProvidersFrom(XpoPageNotFoundRoutingModule),
    // XpoSnackBar is `providedIn: XpoSnackBarModule`, so the module must be instantiated app-wide
    importProvidersFrom(XpoSnackBarModule),
    { provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { appearance: 'outline' } },
  ],
};
